define('home/utils/sidebarUtils',[
], function (
) {
    'use strict';

    var exports = {};

    exports.isSidebar = function () {
        try {
            // If window.self !== window.top then we're iFramed
            // and this is the home sidebar
            return window.self !== window.top;
        } catch (err) {
            // If we got an error, it was a same origin policy error,
            // which means we _are_ in an iFrame.
            return true;
        }
    };

    return exports;
});

